import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminLayout from "@/components/AdminLayout";
import TelecallerLayout from "@/components/TelecallerLayout";
import LandingPage from "@/pages/LandingPage";
import LegalPage from "@/pages/LegalPage";
import Login from "@/pages/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Leads from "@/pages/admin/Leads";
import Employees from "@/pages/admin/Employees";
import Statuses from "@/pages/admin/Statuses";
import Settings from "@/pages/admin/Settings";
import AuditLogs from "@/pages/admin/AuditLogs";
import LandingCMS from "@/pages/admin/LandingCMS";
import FormBuilder from "@/pages/admin/FormBuilder";
import EmailAutomation from "@/pages/admin/EmailAutomation";
import WhatsAppTemplates from "@/pages/admin/WhatsAppTemplates";
import AICalling from "@/pages/admin/AICalling";
import ReactivationAI from "@/pages/admin/ReactivationAI";
import Webinars from "@/pages/admin/Webinars";
import WebinarDetail from "@/pages/admin/WebinarDetail";
import SeoBlog from "@/pages/admin/SeoBlog";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import LeadDetail from "@/pages/LeadDetail";
import Home from "@/pages/telecaller/Home";
import HotLeads from "@/pages/telecaller/HotLeads";
import Followups from "@/pages/telecaller/Followups";
import Notifications from "@/pages/telecaller/Notifications";
import More from "@/pages/telecaller/More";
import TeleLeadDetail from "@/pages/telecaller/TeleLeadDetail";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          {/* Public */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="/p/:slug" element={<LandingPage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/login" element={<Login />} />

          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="leads" element={<Leads />} />
            <Route path="leads/:id" element={<LeadDetail mode="admin" />} />
            <Route path="employees" element={<Employees />} />
            <Route path="statuses" element={<Statuses />} />
            <Route path="landing" element={<LandingCMS />} />
            <Route path="form" element={<FormBuilder />} />
            <Route path="email" element={<EmailAutomation />} />
            <Route path="whatsapp" element={<WhatsAppTemplates />} />
            <Route path="ai" element={<AICalling />} />
            <Route path="reactivation" element={<ReactivationAI />} />
            <Route path="webinars" element={<Webinars />} />
            <Route path="webinars/:id" element={<WebinarDetail />} />
            <Route path="seo" element={<SeoBlog />} />
            <Route path="settings" element={<Settings />} />
            <Route path="audit" element={<AuditLogs />} />
          </Route>

          {/* Telecaller — mobile-first sales panel */}
          <Route path="/app" element={<ProtectedRoute roles={["employee"]}><TelecallerLayout /></ProtectedRoute>}>
            <Route index element={<Home />} />
            <Route path="hot" element={<HotLeads />} />
            <Route path="followups" element={<Followups />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="more" element={<More />} />
            <Route path="leads/:id" element={<TeleLeadDetail />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
